var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9795 5.76099C10.978 5.76099 8.54485 8.19416 8.54485 11.1956C8.54485 14.1971 10.978 16.6303 13.9795 16.6303C15.4865 16.6303 16.8503 16.0168 17.8348 15.026C18.811 14.0436 19.4141 12.69 19.4141 11.1956C19.4141 8.19416 16.981 5.76099 13.9795 5.76099ZM19.905 15.6865C20.8521 14.4388 21.4141 12.8829 21.4141 11.1956C21.4141 7.08959 18.0855 3.76099 13.9795 3.76099C9.87345 3.76099 6.54485 7.08959 6.54485 11.1956C6.54485 15.3017 9.87345 18.6303 13.9795 18.6303C15.6772 18.6303 17.242 18.0612 18.4936 17.1035L21.3131 19.9435C21.7022 20.3354 22.3354 20.3377 22.7273 19.9486C23.1193 19.5595 23.1216 18.9263 22.7324 18.5344L19.905 15.6865Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03418 6.68709C2.03418 6.1348 2.48189 5.68709 3.03418 5.68709L5.25472 5.68709C5.80701 5.68709 6.25472 6.1348 6.25472 6.68709C6.25472 7.23937 5.80701 7.68709 5.25472 7.68709L3.03418 7.68709C2.4819 7.68709 2.03418 7.23937 2.03418 6.68709Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03418 11.3419C2.03418 10.7896 2.48189 10.3419 3.03418 10.3419H4.1435C4.69578 10.3419 5.1435 10.7896 5.1435 11.3419C5.1435 11.8941 4.69578 12.3419 4.1435 12.3419H3.03418C2.4819 12.3419 2.03418 11.8941 2.03418 11.3419Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03418 15.9964C2.03418 15.4441 2.48189 14.9964 3.03418 14.9964H5.25472C5.80701 14.9964 6.25472 15.4441 6.25472 15.9964C6.25472 16.5486 5.80701 16.9964 5.25472 16.9964H3.03418C2.4819 16.9964 2.03418 16.5486 2.03418 15.9964Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAlt);
export default __webpack_public_path__ + "static/media/search-alt.7efa2735d291a5a46cf7dff38d26958a.svg";
export { ForwardRef as ReactComponent };